// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 222.35 221.47\"><title>icon-area1</title><g id=\"a9c14ec0-17e2-4fb8-ad22-1b273e5bd36a\" data-name=\"Layer 2\"><g id=\"be582049-4c18-4747-97d4-dead6c3f87d6\" data-name=\"Layer 1\"><path d=\"M189.17,188.48v-22H200v32.81H167.17V188.48Z\"/><path d=\"M200,99.8v21.89H189.51V99.8Z\"/><path d=\"M189.4,66.5h10.53V88.27H189.4Z\"/><path d=\"M189.41,133.18h10.51v21.68H189.41Z\"/><path d=\"M88.84,188.82v10.37h-22V188.82Z\"/><path d=\"M155.6,188.73v10.55H133.68V188.73Z\"/><path d=\"M100.31,199.29v-10.5H122v10.5Z\"/><path d=\"M200.23,22.11V0H189.08V22h-167V188.45H0v11.14H22.22v21.88h11.1v-22h21.8V188.41H33.61V33.25H189.15V55h11.16V33.08h22v-11Z\"/></g></g></svg>";
// Exports
module.exports = code;


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader/dist/cjs.js!./src/assets/icons/icon-1-area.svg
// module id = LhEy
// module chunks = 34